import React from 'react';
import { ArrowRight, Shield, CheckCircle, Clock } from 'lucide-react';
import { heroData } from '../data/mockData';

const Hero = ({ landing }) => {
  const title = landing?.h1 || heroData.title;
  const subtitle = landing?.subtitle || heroData.subtitle;
  const description = landing?.lead || heroData.description;

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title" data-testid="hero-title">
            {title}
            <span className="hero-subtitle">{subtitle}</span>
          </h1>
          <p className="hero-description" data-testid="hero-description">{description}</p>
          
          {/* Trust Badges */}
          <div className="hero-trust-badges">
            <div className="trust-badge">
              <CheckCircle size={20} className="trust-badge-icon" />
              <span>100% Free Service</span>
            </div>
            <div className="trust-badge">
              <Shield size={20} className="trust-badge-icon" />
              <span>No Obligation</span>
            </div>
            <div className="trust-badge">
              <Clock size={20} className="trust-badge-icon" />
              <span>2 Min Process</span>
            </div>
          </div>
          
          <div className="hero-cta-group">
            <button onClick={scrollToContact} className="hero-cta-primary">
              Find My Agent
              <ArrowRight className="cta-icon" size={20} />
            </button>
            <button 
              onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              className="hero-cta-secondary"
            >
              Learn More
            </button>
          </div>
        </div>
        <div className="hero-image-wrapper">
          <div className="hero-image-container">
            <img 
              src="https://images.pexels.com/photos/8470805/pexels-photo-8470805.jpeg" 
              alt="Happy couple receiving house keys from real estate agent" 
              className="hero-image"
            />
            <div className="hero-image-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
